import { Interoperability } from '../../organisms/Interoperability/Interoperability';

const InteroperabilityPage = () => <Interoperability />;

export default InteroperabilityPage;
